import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/',
  name: 'Home',
  redirect: {
    name: 'ListaContratos'
  },
  meta: {
    titulo: 'Início',
    precisaAutenticacao: false,
    cabecalho: false,
    rodape: false,
    btnHelp: false
  }
}, {
  path: '/contratos',
  name: 'ListaContratos',
  component: function component() {
    return import(/* webpackChunkName: "contrato" */'./pages/ListaContratos');
  },
  meta: {
    titulo: "Contratos",
    precisaAutenticacao: true,
    cabecalho: true,
    rodape: true,
    btnHelp: false,
    chat: true
  }
}, {
  path: '/contratos/:id',
  name: 'Contrato',
  component: function component() {
    return import(/* webpackChunkName: "contrato" */'./pages/Contrato');
  },
  meta: {
    titulo: "Detalhes do contrato",
    precisaAutenticacao: true,
    cabecalho: true,
    rodape: true,
    btnHelp: false,
    footerColor: "#F6F6F6",
    chat: true
  },
  props: function props(route) {
    return {
      id: route.params.id
    };
  }
}, {
  path: '/ajuda',
  name: 'FAQ',
  component: function component() {
    return import(/* webpackChunkName: "publico" */'@/components/MlFaq');
  },
  meta: {
    titulo: 'FAQ',
    precisaAutenticacao: false,
    cabecalho: true,
    rodape: true
  }
}];